import { registerNodeType } from '../../registry'
import { ICONIFY } from '../../../../../Constants/iconify'
import TextAreaNode from './TextAreaNode'
import TextAreaConfig from './TextAreaConfig'

registerNodeType({
  type: 'TEXT_AREA',
  label: 'Text Area',
  icon: ICONIFY.TEXT_AREA,
  color: '#7E57C2',
  hasOptions: false,
  excludeFields: ['inputMode'],
  defaults: {},
  nodeComponent: TextAreaNode,
  configComponent: TextAreaConfig,
})
